import routerOptions0 from "/home/staging/git/fluent-ui/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  linkActiveClass: "active-link",
  linkExactActiveClass: "exact-active-link",
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}